import { type ReactNode } from 'react'
import { cn } from '@/lib/utils'

type IconType = React.ComponentType<React.SVGProps<SVGSVGElement>>

/**
 * Friendly empty state: a soft turquoise accent circle (an approved brand
 * accent shape, §5), a title, optional advisory line (tone of voice §1), and an
 * optional action. Replaces the bare one-line "No X" messages.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: {
  icon?: IconType
  title: string
  description?: string
  action?: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-card border border-dashed border-zinc-950/10 px-6 py-16 text-center',
        className,
      )}
    >
      {Icon && (
        <div className="flex size-12 items-center justify-center rounded-full bg-brand-turquoise/10 text-brand-turquoise">
          <Icon aria-hidden="true" className="size-6" />
        </div>
      )}
      <p className="mt-4 font-heading text-h3 font-bold text-text-strong">{title}</p>
      {description && <p className="mt-1 max-w-md text-sm text-text/70">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
